import { useState, useEffect, useCallback, useRef } from "react";
import EntryConfigTable from "./EntryConfigTable.js";
import UrlConfigTable from "./UrlConfigTable.js";
import UsersTable from "./UsersTable.js";
import left from "../../vendor/arrow-left.svg";
import right from "../../vendor/arrow-right.svg";
import exit from "../../vendor/exit.svg";
import Reports from "./Reports.js";
import { api } from "../../utils/api.js";
import { ENDPOINTS as E } from "../../utils/endpoints.js";
import "./Admin.css";

const Admin = ({ users, setUsers, handleLogout, refreshUsers }) => {
  const [isOpened, setOpened] = useState(false);
  const [isNeedAddRec, setNeedAddRec] = useState(false);
  const [isNeedShowUsers, setNeedShowUsers] = useState(false);
  const [configSource, setConfigSource] = useState("");
  const [sourceData, setSourceData] = useState(null);
  const [newValues, setNewValues] = useState({});
  const [visibilityFilter, setVisibilityFilter] = useState("all");

  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  async function changeUsage(name, val) {
    const data = [configSource, name, val];
    setSourceData(null);
    await api.post(E.CHANGE_USAGE, 4, { data: data });
    getData();
  }

  async function addRecord() {
    const data = Object.assign({}, newValues, { type: configSource });
    setSourceData(null);
    await api.post(E.ADD_CONFIG, 4, { data: [data] });
    setNeedAddRec(false);
    setNewValues({});
    getData();
  }

  const getData = useCallback(async () => {
    if (!configSource) {
      setSourceData(null);
      return;
    }
    const resp = await api.post(E.GET_CONFIGS, 4, {
      data: [configSource],
    });

    if (isMounted.current && resp?.success && resp?.data?.length) {
      setSourceData(resp.data || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configSource, isNeedAddRec]);

  useEffect(() => {
    if (configSource !== "") {
      getData();
    } else {
      setSourceData(null);
    }
  }, [configSource, getData]);

  const handleAddClick = () => {
    if (!isNeedAddRec) {
      setNeedAddRec(true);
    } else {
      addRecord();
    }
  };

  const renderTable = () => {
    if (!sourceData && configSource !== "") {
      return <div>Загрузка...</div>;
    }

    if (!sourceData) {
      return null;
    }

    if (configSource === "url") {
      return (
        <UrlConfigTable
          sourceData={sourceData}
          isNeedAddRec={isNeedAddRec}
          changeUsage={changeUsage}
          setNewValues={setNewValues}
          newValues={newValues}
          handleAddClick={handleAddClick}
        />
      );
    } else {
      return (
        <EntryConfigTable
          resp={sourceData}
          isNeedAddRec={isNeedAddRec}
          setNeedAddRec={setNeedAddRec}
          configSource={configSource}
          changeUsage={changeUsage}
          getData={getData}
        />
      );
    }
  };

  function callReset() {
    setConfigSource("");
    setNeedShowUsers(false);
  }

  function toggleShowUsers() {
    if (!isNeedShowUsers) {
      setConfigSource("");
    }
    setNeedShowUsers(!isNeedShowUsers);
  }

  return (
    <aside className={`adminPanel ${isOpened && "adminPanel_opened"}`}>
      <div
        className={`adminPanel-header ${
          isOpened && "adminPanel-header_opened"
        }`}
      >
        <img
          className="icon"
          src={isOpened ? right : left}
          alt={isOpened ? "свернуть" : "развернуть"}
          onClick={() => {
            setOpened(!isOpened);
          }}
        />
        <div
          style={{ width: "75px", display: "flex", alignItems: "center" }}
          onClick={handleLogout}
        >
          <label
            class="header_label"
            style={{ color: "#fff", cursor: "pointer" }}
          >
            Выйти&nbsp;
          </label>
          <img className="icon" src={exit} alt="выйти" />
        </div>
      </div>
      <section>
        <Reports
          needReset={isNeedShowUsers || configSource !== ""}
          callReset={callReset}
        />
        <div className="input_block input_block_admin">
          <strong>Конфигурирование ресурсов</strong>
          <select
            defaultValue=""
            onChange={(e) => {
              setNeedShowUsers(false);
              setNeedAddRec(false);
              setConfigSource(e.target.value);
            }}
          >
            <option value="">Выберите ресурс</option>
            <option value="avito">Avito</option>
            <option value="email">Почта</option>
            <option value="url">Ссылки</option>
          </select>
        </div>
        {renderTable()}
        <div className="input_block select_block">
          <strong>Пользователи системы</strong>
          <button onClick={toggleShowUsers}>
            {!isNeedShowUsers ? "Показать " : "Скрыть "}пользователей
          </button>
        </div>
        {isNeedShowUsers ? (
          <div className="input_block select_block">
            <strong>Отображение пользователей</strong>
            <select
              onChange={(e) => {
                setVisibilityFilter(e.target.value);
              }}
            >
              <option value={"all"}>Все</option>
              <option value={"users"}>Сотрудники</option>
              <option value={"clients"}>Клиенты</option>
            </select>
          </div>
        ) : null}
        {isNeedShowUsers && (
          <UsersTable
            users={users}
            setUsers={setUsers}
            refreshUsers={refreshUsers}
            visibilityFilter={visibilityFilter}
          />
        )}
      </section>
    </aside>
  );
};

export default Admin;
